import Plyr from 'plyr';

export default class Video {
    constructor() {
        console.log('%c👍🏼 Video', 'color: yellow');

        this.videos = document.querySelectorAll('.video');
    }
    init() {
        this.videos.forEach((elem, i) => {

            let video = elem.querySelector('.plyr__video__wrapper');
            let playButton =  elem.querySelector('.video__button');            

            playButton.addEventListener('click', () => {
                if (!Cookiebot.consent.marketing) {
                    Cookiebot.show();
                    return;
                }

                elem.classList.add('hide');

                const player = new Plyr(video, {
                    youtube: { 
                        noCookie: true,
                        rel: 0, 
                        showinfo: 0, 
                        iv_load_policy: 3, 
                        modestbranding: 1 
                    }
                });

                player.volume = 0.5;
                player.play();

                let observer = new IntersectionObserver((entries) => { 
                    entries.forEach(entry => {
                        if(entry.intersectionRatio!=1){
                            player.pause();
                        }
                    
                    });
                }, {threshold: 1});
                observer.observe(video);
            });
        })
    }
}

